module.exports = __webpack_public_path__ + "img/gateway.429731d0.png";